<template>
    <nav>
        <div class="container">
            <router-link :to="{name: 'admin.administrators'}">
                <slot/>
                Administrateurs
            </router-link>
            <router-link :to="{name: 'admin.courses'}">
                <slot/>
                Cours
            </router-link>
            <router-link :to="{name: 'admin.options'}">
                <slot/>
                Options
            </router-link>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "RichAdminHeaderSecondaryLevel"
    }
</script>

<style scoped lang="scss">
    nav{
        width: 100%;
        position:fixed;
        top:72px;
        left:0;
        background: var(--color-grey-light-2);
        height: 48px;
    }
    .container{
        max-width: 780px;
        display:flex;
        align-items: center;
        height: 100%;
        >a{
            margin-right: 24px;
            position: relative;
            &:hover{
                color:var(--color-primary);
            }
            &.router-link-exact-active{
                color:var(--color-primary);
                &:before{
                    content: "";
                    position:absolute;
                    height: 3px;
                    background: var(--color-primary);
                    width: 120%;
                    margin-left: -10%;
                    bottom:-15px;
                }
            }
        }
    }
</style>
